import * as moment from 'moment-timezone'

export default function timezoneChecker() {
    let isDifferentTimeZone = false
    let now = moment()
    const isSummerTime = now.tz('Europe/Prague').isDST()
    now = moment()
    if ((isSummerTime && now.utcOffset() !== 120) || (!isSummerTime && now.utcOffset() !== 60)) {
        isDifferentTimeZone = true
    }
    return {isDifferentTimeZone, isSummerTime}
}